import React, { Fragment } from "react";

export default (
  <>
    <path d="M0 12h3.42857v12H0zm20.5713-6h3.42857v18H20.5713zM10.2856 0h3.42857v24H10.2856z" />
  </>
);
